module.exports = __webpack_public_path__ + "fonts/iconfont.735d592.woff";